// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1734":"4dd20b22","5998":"3230c59b"}[chunkId] + ".chunk.css";
};